
import IconButton from '@mui/joy/IconButton';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Select from '@mui/joy/Select';
import Option from '@mui/joy/Option';
import ToggleButtonGroup from '@mui/joy/ToggleButtonGroup';
import Tooltip from '@mui/joy/Tooltip';
// import AutoDeleteRoundedIcon from '@mui/icons-material/AutoDeleteRounded';
// import FactCheckRoundedIcon from '@mui/icons-material/FactCheckRounded';
import CheckBoxOutlineBlankRoundedIcon from '@mui/icons-material/CheckBoxOutlineBlankRounded';
import IndeterminateCheckBoxRoundedIcon from '@mui/icons-material/IndeterminateCheckBoxRounded';
import CheckBoxRoundedIcon from '@mui/icons-material/CheckBoxRounded';

type ToggleMultiSelectProps = {
    enabled: boolean,
    toggled: boolean,
    onChange: any
};

export default function ToggleMultiSelect({
    enabled,
    toggled,
    onChange,
    ...restProps
}: ToggleMultiSelectProps) {

    return (
        <Tooltip title={toggled ? 'Disable Bulk Edit' : 'Enable Bulk Edit'}>
            <IconButton disabled={!enabled} onClick={() => onChange(!toggled)} sx={{ bgcolor: 'background.surface' }} {...restProps}>
                {toggled === true && (<IndeterminateCheckBoxRoundedIcon/>)}
                {toggled !== true && (<CheckBoxRoundedIcon/>)}
            </IconButton>
        </Tooltip>
    );
}
